import { VisitEvent } from "../scripts/visits.entities";


export class VisitsDatatableEntry {
    Study: string;
    Appendix: string;
    Site: string;
    SiteNumber: string;
    Visit: string;

    PotentialVisits: number;
    ExpectedVisits: number;
    Completed: number[] = [];
    Overdue: number[] = [];
    NotDone: number[] = [];
    DiscPrior: number[] = [];
    NotYetDue: number;

    CompletedVisits: VisitEvent[] = [];
    OverdueVisits: VisitEvent[] = [];
    NotDoneVisits: VisitEvent[] = [];
    DiscPriorVisits: VisitEvent[] = [];

    sortValue: number;

    constructor(study: string, appendix: string, site: string, siteNumber: string, visit: string) {
        this.Study = study;
        this.Appendix = appendix;
        this.Site = site;
        this.SiteNumber = siteNumber;
        this.Visit = visit;

        this.PotentialVisits = 0;
        this.ExpectedVisits = 0;
        this.NotYetDue = 0;
    }

    addVisitEvent(visit: VisitEvent): void {
        this.PotentialVisits += 1;

        switch (visit.VisitStatusId) {
            case 1: this.Completed[0] = (this.Completed[0] == undefined) ? 1 : (this.Completed[0] + 1); this.ExpectedVisits += 1; this.CompletedVisits.push(visit); break;
            //case 2: this.NotYetDone = (this.NotYetDone == undefined) ? 1 : (this.NotYetDone + 1); break;
            case 3: this.Overdue[0] = (this.Overdue[0] == undefined) ? 1 : (this.Overdue[0] + 1); this.ExpectedVisits += 1; this.OverdueVisits.push(visit); break;
            case 4: this.NotDone[0] = (this.NotDone[0] == undefined) ? 1 : (this.NotDone[0] + 1); this.ExpectedVisits += 1; this.NotDoneVisits.push(visit); break;
            case 5: this.DiscPrior[0] = (this.DiscPrior[0] == undefined) ? 1 : (this.DiscPrior[0] + 1); this.ExpectedVisits += 1; this.DiscPriorVisits.push(visit); break;
            case 6:
            case 7:
                this.NotYetDue = (this.NotYetDue == undefined) ? 1 : (this.NotYetDue + 1); break;
        }        
    }

    initialize(): void {
        if (this.ExpectedVisits > 0) {
            if (this.Completed[0] != undefined) { this.Completed[1] = (this.Completed[0] / this.ExpectedVisits); }
            if (this.Overdue[0] != undefined) { this.Overdue[1] = (this.Overdue[0] / this.ExpectedVisits); }
            if (this.NotDone[0] != undefined) { this.NotDone[1] = (this.NotDone[0] / this.ExpectedVisits); }
            if (this.DiscPrior[0] != undefined) { this.DiscPrior[1] = (this.DiscPrior[0] / this.ExpectedVisits); }
        }
    }

    static addValue(currentValue: number, valueToAdd: number): number {
        if (currentValue == undefined) { currentValue = 0; }
        currentValue += valueToAdd;
        return currentValue;
    }

    static getHash(grouping: string, visit: VisitEvent): string {
        if (grouping == "none") { return visit.StudyId + "-" + visit.AppendixId + "-" + visit.SiteNumber + "-" + visit.VisitId; }
        else if (grouping == "by-visit") { return visit.StudyId + "-" + visit.AppendixId + "-" + visit.VisitId; }
        else if (grouping == "by-site") { return visit.StudyId + "-" + visit.AppendixId + "-" + visit.SiteNumber; }
        else return "unknown";
    }
}